import { Toast } from "@aurem/ui";
import type { FC } from "react";
import { useCallback, useEffect } from "react";

export const NetworkStatus: FC = () => {
  const handleOffline = useCallback(() => {
    Toast.error({
      title: "No Internet Connection",
      text: "You are offline. Check your network connection.",
    });
  }, []);

  const handleOnline = useCallback(() => {
    Toast.info({
      title: "Back Online",
      text: "Internet connection restored.",
    });
  }, []);

  useEffect(() => {
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [handleOffline, handleOnline]);

  return null;
};
